/* =============================================================
   NAVKARMA NATURAL — THEME JS
   Cart · Mobile Menu · Tabs · Gallery · Filters · Variants
   ============================================================= */

(function () {
  'use strict';

  /* ─── Helpers ─────────────────────────────────────────────── */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }
  function on(el, evt, fn, opts) { if (el) el.addEventListener(evt, fn, opts); }
  function formatMoney(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 0 });
  }

  /* ─── Cart API ─────────────────────────────────────────────── */
  const Cart = {
    get: function () {
      return fetch(Navkarma.routes.cart_get, { headers: { 'Content-Type': 'application/json' } }).then(function (r) { return r.json(); });
    },
    add: function (variantId, qty) {
      return fetch(Navkarma.routes.cart_add, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty || 1 })
      }).then(function (r) { return r.json(); });
    },
    change: function (line, qty) {
      return fetch(Navkarma.routes.cart_change, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then(function (r) { return r.json(); });
    }
  };

  /* ─── Cart Drawer ──────────────────────────────────────────── */
  var cartDrawer   = $('#cart-drawer');
  var cartOverlay  = $('#cart-overlay');
  var cartClose    = $('#cart-close');
  var cartItemsEl  = $('#cart-items');
  var cartTotalEl  = $('#cart-total-price');

  function openCartDrawer() {
    if (!cartDrawer) return;
    Cart.get().then(renderCartDrawer);
    cartDrawer.classList.add('open');
    cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  function renderCartDrawer(cart) {
    updateCartCount(cart.item_count);
    if (cartTotalEl) cartTotalEl.textContent = formatMoney(cart.total_price);
    if (!cartItemsEl) return;

    if (cart.item_count === 0) {
      cartItemsEl.innerHTML = '<div class="cart-empty"><div class="cart-empty__icon">🛒</div><p class="cart-empty__text">Your cart is empty</p><a href="/collections/all" class="btn btn-primary btn-sm">Start Shopping</a></div>';
      return;
    }

    cartItemsEl.innerHTML = cart.items.map(function (item, idx) {
      var imgSrc = item.image ? item.image.replace('.jpg', '_120x.jpg').replace('.png', '_120x.png').replace('.webp', '_120x.webp') : '';
      return [
        '<div class="cart-item" data-line="' + (idx + 1) + '">',
          '<div class="cart-item__image">' + (imgSrc ? '<img src="' + imgSrc + '" alt="' + item.title + '" loading="lazy">' : '') + '</div>',
          '<div class="cart-item__info">',
            '<div class="cart-item__title">' + item.product_title + '</div>',
            item.variant_title !== 'Default Title' ? '<div style="font-size:11px;color:#888;margin-top:2px;">' + item.variant_title + '</div>' : '',
            '<div class="cart-item__price">' + formatMoney(item.final_line_price) + '</div>',
            '<div class="cart-item__qty">',
              '<button class="cart-qty-btn cart-qty-dec" data-line="' + (idx + 1) + '" data-qty="' + Math.max(0, item.quantity - 1) + '" aria-label="Decrease">−</button>',
              '<span>' + item.quantity + '</span>',
              '<button class="cart-qty-btn cart-qty-inc" data-line="' + (idx + 1) + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase">+</button>',
            '</div>',
          '</div>',
          '<button class="cart-item__remove icon-btn" data-line="' + (idx + 1) + '" aria-label="Remove item">',
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
          '</button>',
        '</div>'
      ].join('');
    }).join('');

    /* Bind qty / remove buttons */
    $$('.cart-qty-btn', cartItemsEl).forEach(function (btn) {
      on(btn, 'click', function () {
        Cart.change(parseInt(btn.dataset.line), parseInt(btn.dataset.qty)).then(renderCartDrawer);
      });
    });
    $$('.cart-item__remove', cartItemsEl).forEach(function (btn) {
      on(btn, 'click', function () {
        Cart.change(parseInt(btn.dataset.line), 0).then(renderCartDrawer);
      });
    });
  }

  function updateCartCount(count) {
    $$('.cart-count').forEach(function (el) {
      el.textContent = count || 0;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  on(cartOverlay, 'click', closeCartDrawer);
  on(cartClose, 'click', closeCartDrawer);

  /* Open cart on all [data-cart-open] triggers */
  on(document, 'click', function (e) {
    var trigger = e.target.closest('[data-cart-open]');
    if (trigger) { e.preventDefault(); openCartDrawer(); }
  });

  /* ─── Add to Cart ──────────────────────────────────────────── */
  on(document, 'click', function (e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    var variantId = btn.dataset.addToCart;
    if (!variantId) return;

    var originalText = btn.textContent;
    btn.textContent = Navkarma.strings.adding;
    btn.disabled = true;

    Cart.add(variantId).then(function (res) {
      if (res.status) {
        btn.textContent = res.description || 'Error';
        btn.disabled = false;
        return;
      }
      btn.textContent = Navkarma.strings.added;
      btn.style.background = '#27AE60';
      setTimeout(function () {
        btn.textContent = originalText;
        btn.style.background = '';
        btn.disabled = false;
      }, 1600);
      openCartDrawer();
    }).catch(function () {
      btn.textContent = originalText;
      btn.disabled = false;
    });
  });

  /* ─── Product Form (Product Page) ─────────────────────────── */
  var productForm = $('#product-form');
  if (productForm) {
    on(productForm, 'submit', function (e) {
      e.preventDefault();
      var submitBtn = productForm.querySelector('[type=submit]');
      var variantInput = productForm.querySelector('[name="id"]');
      if (!variantInput || !submitBtn) return;

      var originalText = submitBtn.textContent;
      submitBtn.textContent = Navkarma.strings.adding;
      submitBtn.disabled = true;

      Cart.add(variantInput.value, 1).then(function (res) {
        if (res.status) {
          submitBtn.textContent = 'Error: ' + (res.description || 'Try again');
          submitBtn.disabled = false;
          return;
        }
        submitBtn.textContent = Navkarma.strings.added;
        submitBtn.style.background = '#27AE60';
        setTimeout(function () {
          submitBtn.textContent = originalText;
          submitBtn.style.background = '';
          submitBtn.disabled = false;
        }, 1600);
        openCartDrawer();
      }).catch(function () {
        submitBtn.textContent = originalText;
        submitBtn.disabled = false;
      });
    });
  }

  /* ─── Mobile Menu ──────────────────────────────────────────── */
  var mobileMenu    = $('#mobile-menu');
  var mobileOverlay = $('#mobile-menu-overlay');
  var mobileClose   = $('#mobile-menu-close');
  var hamburger     = $('.hamburger-btn');

  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('open');
    document.body.style.overflow = '';
  }

  on(hamburger, 'click', openMobileMenu);
  on(mobileClose, 'click', closeMobileMenu);
  on(mobileOverlay, 'click', closeMobileMenu);

  /* ─── Header Scroll ────────────────────────────────────────── */
  var siteHeader = $('.site-header');
  if (siteHeader) {
    function handleHeaderScroll() {
      if (window.scrollY > 80) {
        siteHeader.classList.add('scrolled-light');
      } else {
        siteHeader.classList.remove('scrolled-light');
      }
    }
    window.addEventListener('scroll', handleHeaderScroll, { passive: true });
    handleHeaderScroll();
  }

  /* ─── Best Sellers Tabs ────────────────────────────────────── */
  $$('.tabs').forEach(function (tabsEl) {
    var btns   = $$('.tab-btn', tabsEl);
    var panels = $$('.tab-panel');

    btns.forEach(function (btn) {
      on(btn, 'click', function () {
        var target = btn.dataset.tab;
        btns.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        panels.forEach(function (p) {
          if (p.dataset.tab === target) p.classList.add('active');
          else p.classList.remove('active');
        });
      });
    });
  });

  /* ─── Product Page Gallery ─────────────────────────────────── */
  var galleryMain  = $('#gallery-main-img');
  var galleryThumbs = $$('.gallery-thumb');

  galleryThumbs.forEach(function (thumb) {
    on(thumb, 'click', function () {
      var newSrc = thumb.dataset.src;
      if (galleryMain && newSrc) {
        galleryMain.src = newSrc;
        galleryThumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      }
    });
  });

  /* ─── Product Tabs (Description / Ingredients / How to Use) ── */
  $$('.product-tab-btn').forEach(function (btn) {
    on(btn, 'click', function () {
      var target = btn.dataset.tab;
      $$('.product-tab-btn').forEach(function (b) { b.classList.remove('active'); });
      $$('.product-tab-content').forEach(function (c) { c.classList.remove('active'); });
      btn.classList.add('active');
      var panel = document.getElementById('tab-' + target);
      if (panel) panel.classList.add('active');
    });
  });

  /* ─── Variant Selector ─────────────────────────────────────── */
  var variantSelect = $('#product-variant-select');
  var variantInput  = document.querySelector('[name="id"][form="product-form"]');
  if (variantSelect && variantInput) {
    on(variantSelect, 'change', function () {
      variantInput.value = variantSelect.value;
    });
  }

  /* Swatch / pill variant selectors */
  $$('.variant-btn').forEach(function (btn) {
    on(btn, 'click', function () {
      var group = btn.closest('.variant-group');
      if (!group) return;
      $$('.variant-btn', group).forEach(function (b) { b.classList.remove('selected'); });
      btn.classList.add('selected');
      /* Update hidden id if single-option product */
      var varId = btn.dataset.variantId;
      if (varId && variantInput) variantInput.value = varId;
    });
  });

  /* ─── Collection Filter Sidebar Toggles ────────────────────── */
  $$('.filter-group-toggle').forEach(function (toggle) {
    on(toggle, 'click', function () {
      var body = toggle.nextElementSibling;
      if (!body) return;
      var isOpen = body.classList.toggle('open');
      toggle.classList.toggle('open', isOpen);
    });
  });

  /* ─── Mobile Filter Drawer ─────────────────────────────────── */
  var filterDrawer  = $('#filter-drawer');
  var filterOverlay = $('#filter-drawer-overlay');
  var filterOpen    = $('.mobile-filter-btn');
  var filterClose   = $('#filter-drawer-close');

  function openFilterDrawer() { if (filterDrawer) { filterDrawer.classList.add('open'); if (filterOverlay) filterOverlay.classList.add('open'); document.body.style.overflow = 'hidden'; } }
  function closeFilterDrawer() { if (filterDrawer) { filterDrawer.classList.remove('open'); if (filterOverlay) filterOverlay.classList.remove('open'); document.body.style.overflow = ''; } }

  on(filterOpen, 'click', openFilterDrawer);
  on(filterClose, 'click', closeFilterDrawer);
  on(filterOverlay, 'click', closeFilterDrawer);

  /* ─── Quickview Modal ──────────────────────────────────────── */
  var quickviewModal   = $('#quickview-modal');
  var quickviewOverlay = $('#quickview-overlay');
  var quickviewClose   = $('#quickview-close');
  var quickviewContent = $('#quickview-content');

  on(quickviewOverlay, 'click', closeQuickview);
  on(quickviewClose,   'click', closeQuickview);

  function closeQuickview() {
    if (quickviewModal) { quickviewModal.classList.remove('open'); document.body.style.overflow = ''; }
  }

  on(document, 'click', function (e) {
    var btn = e.target.closest('[data-quickview]');
    if (!btn || !quickviewModal) return;
    var handle = btn.dataset.quickview;
    if (!handle) return;
    quickviewModal.classList.add('open');
    document.body.style.overflow = 'hidden';
    if (quickviewContent) {
      quickviewContent.innerHTML = '<div style="padding:40px;text-align:center;"><div style="font-size:24px;margin-bottom:8px;">⏳</div><p>Loading...</p></div>';
    }
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        var img = product.featured_image ? product.featured_image.replace('http://', 'https://') : '';
        var price = formatMoney(product.price);
        var compare = product.compare_at_price > product.price ? formatMoney(product.compare_at_price) : '';
        quickviewContent.innerHTML = [
          '<div style="display:grid;grid-template-columns:1fr 1fr;gap:0;min-height:400px;">',
            '<div style="background:var(--clr-bg-2);">' + (img ? '<img src="' + img + '" alt="' + product.title + '" style="width:100%;height:100%;object-fit:cover;">' : '') + '</div>',
            '<div style="padding:32px;display:flex;flex-direction:column;gap:16px;">',
              '<div style="font-size:11px;font-weight:800;letter-spacing:0.15em;text-transform:uppercase;color:var(--clr-accent);">' + (product.product_type || 'Navkarma') + '</div>',
              '<h3 style="font-family:var(--font-display);font-size:22px;font-weight:800;">' + product.title + '</h3>',
              '<div style="display:flex;gap:10px;align-items:center;">',
                '<span style="font-size:22px;font-weight:800;">' + price + '</span>',
                (compare ? '<span style="text-decoration:line-through;color:#888;font-size:14px;">' + compare + '</span>' : ''),
              '</div>',
              '<button class="btn btn-primary btn-full" data-add-to-cart="' + product.variants[0].id + '">Add to Cart</button>',
              '<a href="/products/' + handle + '" class="btn btn-outline btn-full">View Full Details</a>',
            '</div>',
          '</div>'
        ].join('');
      })
      .catch(function () {
        quickviewContent.innerHTML = '<div style="padding:40px;text-align:center;">Failed to load product. <a href="/products/' + handle + '">View product</a></div>';
      });
  });

  /* ─── Wishlist (localStorage) ──────────────────────────────── */
  var wishlist = JSON.parse(localStorage.getItem('nk_wishlist') || '[]');

  function saveWishlist() { localStorage.setItem('nk_wishlist', JSON.stringify(wishlist)); }

  $$('[data-wishlist]').forEach(function (btn) {
    var id = btn.dataset.wishlist;
    if (wishlist.indexOf(id) > -1) btn.classList.add('active');

    on(btn, 'click', function () {
      var idx = wishlist.indexOf(id);
      if (idx > -1) {
        wishlist.splice(idx, 1);
        btn.classList.remove('active');
      } else {
        wishlist.push(id);
        btn.classList.add('active');
      }
      saveWishlist();
    });
  });

  /* ─── Before/After Slider ──────────────────────────────────── */
  var baSlider = $('#ba-slider');
  if (baSlider) {
    var baHandle = $('#ba-handle');
    var baAfter  = baSlider.querySelector('.ba-after');
    var dragging = false;

    function setBAPosition(x) {
      var rect = baSlider.getBoundingClientRect();
      var pct  = Math.min(Math.max((x - rect.left) / rect.width * 100, 2), 98);
      if (baAfter)  baAfter.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
      if (baHandle) baHandle.style.left = pct + '%';
    }

    if (baAfter)  baAfter.style.clipPath  = 'inset(0 0 0 40%)';
    if (baHandle) baHandle.style.left     = '40%';

    on(baHandle, 'mousedown',  function () { dragging = true; });
    on(window,   'mouseup',    function () { dragging = false; });
    on(window,   'mousemove',  function (e) { if (dragging) setBAPosition(e.clientX); });
    on(baHandle, 'touchstart', function () { dragging = true; }, { passive: true });
    on(window,   'touchend',   function () { dragging = false; });
    on(window,   'touchmove',  function (e) { if (dragging) setBAPosition(e.touches[0].clientX); }, { passive: true });
    on(baSlider, 'click',      function (e) { setBAPosition(e.clientX); });
  }

  /* ─── Hero Video Mute Toggle ───────────────────────────────── */
  var heroVideo   = $('#hero-video');
  var heroMuteBtn = $('#hero-mute-btn');
  if (heroVideo && heroMuteBtn) {
    on(heroMuteBtn, 'click', function () {
      heroVideo.muted = !heroVideo.muted;
      heroMuteBtn.setAttribute('aria-label', heroVideo.muted ? 'Unmute video' : 'Mute video');
      heroMuteBtn.querySelector('svg')?.setAttribute('data-muted', heroVideo.muted ? '1' : '0');
    });
  }

  /* ─── Cart Page Qty ────────────────────────────────────────── */
  on(document, 'click', function (e) {
    var btn = e.target.closest('.cart-page-qty-btn');
    if (!btn) return;
    var line = parseInt(btn.dataset.line);
    var qty  = parseInt(btn.dataset.qty);
    Cart.change(line, qty).then(function () { window.location.reload(); });
  });

  /* ─── Init Cart Count ──────────────────────────────────────── */
  Cart.get().then(function (cart) { updateCartCount(cart.item_count); }).catch(function () {});

  /* ─── Keyboard: close modals on Escape ─────────────────────── */
  on(document, 'keydown', function (e) {
    if (e.key === 'Escape') {
      closeCartDrawer();
      closeMobileMenu();
      closeFilterDrawer();
      closeQuickview();
    }
  });

})();
